<div [formGroup]="group" class="title">
  <div class="radio-label">
    {{ label }}
  </div>
  <div class="radiobtn">
    <div *ngFor="let item of items">
      <label class="radio">
        <input
          type="radio"
          id="{{ name }}"
          [formControl]="formControl()"
          [value]="item[valueFieldName]"
          name="{{ name }}"
          [disabled]="disabled"
          (ngModelChange)="onChange($event)" />
        <div class="radio-mark" [tabindex]="tabOrder"></div>
        <div>{{ item[textFieldName] }}</div>
      </label>
    </div>
  </div>
</div>
<div class="error unvisible" *ngIf="f[name]?.touched && f[name]?.invalid" [class.visible]="f[name].touched && f[name]?.invalid">
  <span *ngIf="f[name].errors?.required"> {{ label }} {{ "Errors.Required" | translate }} </span>
</div>
